<template>
    <div>
        <p class="as-name f-inlineblock-top">创作类型</p>
        <div class="f-inlineblock-top fill-in-frame">
            <div class="select fill-in-con-box" @click="showSelectOpt">
                <p
                    class="select-con f-hide-col-1"
                    :style="selectedCreateType.value ? 'color:#666': ''"
                >{{ selectedCreateType.name }}</p>
                <span
                    class="ico"
                    :class="{'ico-down': !selectedCreateType.hide,'ico-up': selectedCreateType.hide}"
                ></span>
                <div
                    class="g-selector-option"
                    :class="{'f-hide': selectedCreateType.hide}"
                    @mouseleave="hideSelectOption"
                >
                    <div class="selector g-scrollbar">
                        <div
                            class="select-item"
                            v-for="(item,index) in createType"
                            :key="index"
                            @click.prevent="selectCreateType(item)"
                        >{{ item.name }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "~Assets/sass/pages/v4/set/set.scss";
.select-con {
    cursor: pointer;
}
</style>
<script>
export default {
    name: "create-type.vue",
    props: ["selected", "editMode"],
    data() {
        return {
            createType: [
                {
                    name: "请选择",
                    value: 0
                },
                {
                    name: "图文攻略性质的图片/文章内容",
                    value: 1
                },
                {
                    name: "攻略/搞笑/解说性质的视频内容",
                    value: 2
                },
                {
                    name: "壁纸/漫画/插画",
                    value: 3
                },
                {
                    name: "微电影/动画片",
                    value: 4
                },
                {
                    name: "小说类",
                    value: 5
                },
                {
                    name: "音乐类",
                    value: 6
                },
                {
                    name: "cos",
                    value: 7
                }
            ],
            selectedCreateType: {
                name: "请选择",
                value: 0,
                hide: true
            }
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            if (typeof this.selected !== undefined) {
                try {
                    let type = this.createType.filter(
                        row => row.value == this.selected
                    );
                    if (type.length) {
                        this.selectedCreateType.name = type[0].name;
                        this.selectedCreateType.value = type[0].value;
                        this.editMode = false;
                    }
                } catch (e) {
                    console.log(e.msg);
                }
            }
        },
        showSelectOpt(ele) {
            if (this.editMode === true) {
                this.selectedCreateType.hide = !this.selectedCreateType.hide;
                $(this.$refs.createTypeInput).focus();
            }
        },
        selectCreateType(type) {
            this.selectedCreateType.name = type.name;
            this.selectedCreateType.value = type.value;
        },
        hideSelectOption() {
            setTimeout(() => {
                this.selectedCreateType.hide = true;
            }, 500);
        }
    },
    watch: {
        "selectedCreateType.value": function(value) {
            if (!parseInt(value)) {
                this.selectedCreateType.value = value;
            } else {
                this.$emit("update:selected", value);
            }
        },
        selected: function(value) {
            if (!parseInt(value)) {
                this.selectedCreateType.value = value;
            }
        }
    }
};
</script>

<style scoped>
</style>
